import { Vec2 } from "utils/math/vec2";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export class CanvasResizeUnitComponent extends Webgl2Component {
  constructor(size: Vec2) {
    super();
    this.transform.setSize(size);
  }

  public getRenderData() {
    const material = Webgl2.materials.backgroundColor;
    material.setUniforms({
      u_color: [0, 0.6, 0.63, 1],
    });
    return { material };
  }
}

export default CanvasResizeUnitComponent;
